import { GzGenericOverlayWebComponent } from './component/GzGenericOverlayWebComponent';
import { GenericOverlayElement } from './component/GenericOverlay';

export { GzGenericOverlayWebComponent, GenericOverlayElement };
